import { useMemo } from 'react';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { INplInfo } from '../../../../service/detail/Detail';

interface IRealEstateStatusProps {
  info: INplInfo;
}

const ItemRow = ({
  label,
  content,
}: {
  label: React.ReactNode;
  content: React.ReactNode;
}) => (
  <s.Item>
    <s.ItemLabel>{label}</s.ItemLabel>
    <s.ItemContent>{content}</s.ItemContent>
  </s.Item>
);

const formatDate = (v?: string) => {
  if (!v) return '-';
  const d = v.split(' ')[0];
  return d.replaceAll('-', '.');
};

const formatArea = (value: unknown, allowEmpty = false) => {
  const raw = (value ?? '').toString().trim();

  if (allowEmpty && raw === '') return '';
  const num = Number(raw);
  if (Number.isNaN(num)) return '-';

  const sqm = ReportFormatNumber(num, true, false);
  const pyeong = ReportFormatNumber(num / 3.3058, true, false);
  return `${sqm}m² (${pyeong}평)`;
};

const isBlank = (v: any) =>
  v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

const withNone = (v: any, present: React.ReactNode) =>
  isBlank(v) ? '해당없음' : present;

const RealEstateStatus = ({ info }: IRealEstateStatusProps) => {
  const rows = useMemo(
    () => [
      { label: '물건종류', content: info.itemcatetory ?? '-' },
      { label: '용도지역', content: info.zoning ?? '-' },

      { label: '토지면적', content: formatArea(info.landarea, false) },

      {
        label: '건물면적(전용)',
        content: withNone(
          info.buildingarea,
          formatArea(info.buildingarea, false),
        ),
      },

      {
        label: '층수',
        content: withNone(info.floor, info.floor ?? '-'),
      },

      {
        label: '사용승인일',
        content: withNone(info.approval_date, formatDate(info.approval_date)),
      },
    ],
    [info],
  );

  return (
    <s.Div>
      <s.Title>부동산 현황</s.Title>
      <div>
        {rows.map((r, i) => (
          <ItemRow key={i} label={r.label} content={r.content} />
        ))}
      </div>
    </s.Div>
  );
};

export default RealEstateStatus;
